"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse = exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest
 */
class LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string ticket_ids = 1;
         */
        this.ticketIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest = LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest";
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * チケットidを元にチケットの詳細情報を取得
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse
 */
class LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary tickets = 1;
         */
        this.tickets = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse, a, b);
    }
}
exports.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse = LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.runtime = protobuf_1.proto3;
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.typeName = "spwn.dashboard.v1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse";
LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tickets", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalIssuedTicketsSummary, repeated: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map